module.exports = __webpack_public_path__ + "static/hero_illustration-88533b53aacef37d4dd6df47af08e80c.svg";